export enum JobPostClickEvents {
  JobPostsListLoaded = 'Job Posts List Loaded',
  JobPostClicked = 'Job Post Clicked',
  ApplicationFormApplyNowClicked = 'Application Form Apply Now Clicked',
  ApplicationFormClicked = 'Application Form Clicked',
  OverviewApplyClicked = 'Overview Apply Clicked',
}
